import React from 'react';
import { Col, Row, SpanConfig } from '@ag1/ui';
import { TrustpilotWidget } from '@portal/shared/studio/TrustpilotWidget/TrustpilotWidget';
import styles from './styles.module.scss';
import FooterLogoSection from '../FooterLogoSection/FooterLogoSection';
import FooterDivider from '../FooterDivider/FooterDivider';
import FooterControls from '../FooterControls/FooterControls';
import FooterDisclaimer from '../FooterDisclaimer/FooterDisclaimer';
import FooterBottomMenu from '../FooterBottomMenu/FooterBottomMenu';
import FooterCopyright from '../FooterCopyright/FooterCopyright';
import { useFooterContext } from '../FooterContext';

const logoColConfig: SpanConfig = { xxs: 12, l: 3, xl: 'auto' };

const FooterContentMainBottom = () => {
  const {
    data: { widget }
  } = useFooterContext();

  return (
    <div className={styles.root}>
      <Row className={styles.topRow}>
        <Col span={logoColConfig} className={styles.logoSection}>
          <div className={styles.logoSectionContent}>
            <FooterLogoSection />
          </div>
        </Col>
        <Col span={12} className={styles.divider}>
          <FooterDivider />
        </Col>
        <Col span={{ xxs: 12, l: 'auto' }} className={styles.controlsSection}>
          <FooterControls />
          {widget && (
            <TrustpilotWidget
              _key="tpw"
              {...widget}
              _type="trustpilotWidget"
              visibleOnPageLoad={false}
              width="100%"
              height="40px"
              className={styles.trustpilot}
            />
          )}
        </Col>
        <Col span={12} className={styles.divider}>
          <FooterDivider />
        </Col>
        <Col
          span={{ xxs: 12, m: 8, l: 5 }}
          offset={{ m: 2, l: 0 }}
          className={styles.disclaimerSection}>
          <FooterDisclaimer />
        </Col>
      </Row>
      <Row className={styles.bottomRow}>
        <Col span={logoColConfig} className={styles.logoColPlaceholder} aria-hidden="true" />
        <Col span={{ xxs: 12, l: 7, xl: 6 }} className={styles.menuSection}>
          <FooterBottomMenu />
        </Col>
        <Col className={styles.copyrightSection}>
          <FooterCopyright />
        </Col>
      </Row>
    </div>
  );
};

export default FooterContentMainBottom;
